module.exports = __webpack_public_path__ + "img/frame1.013a68e9.jpg";